import { AnswerType } from "@/entities/questionaire/answers/AnswerType";
import { Answer } from "@/entities/questionaire/answers/Answer";
import constants from "@/entities/constants";
import { expectedAnswerType } from "@/entities/questionaire/answers/ExpectedAnswerType";

export class BooleanAnswer extends Answer {
  answer: boolean | null = null;
  expectedAnswer: expectedAnswerType;
  text: string | null = null;

  constructor(
    PropertyId: number,
    answer: boolean | null = null,
    text: string | null = null,
    expectedAnswer: expectedAnswerType = expectedAnswerType.none
  ) {
    super(PropertyId);
    this.answer = answer;
    this.text = text;
    this.expectedAnswer = expectedAnswer;
  }

  getType(): AnswerType {
    return AnswerType.Boolean;
  }

  isEmpty(): boolean {
    return this.answer === null;
  }

  getComponentName(): string {
    return constants.answerTypes.BooleanAnswer.componentName;
  }

  getQuizResultObject(): any {
    return {
      propertyId: this.PropertyId,
      answerType: this.getType(),
      boolean: this.answer
    };
  }

  get isDataCompleted() {
    return this.expectedAnswer !== expectedAnswerType.none;
  }
}
